import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { submitSignUpForm } from '@/utils/analytics/log-event';
import { signUp } from '@/utils/myshands-api';

import { schema, Schema } from './form-schema';
import { Props } from './props';

const useHook = ({ lpName }: Props) => {
  const [isSucceeded, setIsSucceeded] = useState(false);

  const {
    control,
    setError,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues: {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      approveTermsOfUse: false,
    },
  });

  const submit = handleSubmit(async (data: Schema) => {
    const response = await signUp({
      email: data.email,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
      lpName,
    });

    setIsSucceeded(response.success);

    if (response.success) {
      submitSignUpForm();
    } else {
      Object.entries(response.fieldErrors).forEach(([key, value]) => {
        setError(key as keyof Schema, { message: value.fullMessages.join('') });
      });
    }
  });

  return {
    submit,
    control,
    isSucceeded,
    isSubmitting,
  };
};

export default useHook;
